import { createContext, useContext } from "react";

/**
 * Lets the time-series list (deep inside the Settings panel) ask the obs-map
 * editor form to open the configurator. The editor form owns the open/index
 * state so it can present the configurator in the location dictated by the
 * active dev "sub-settings" variant (dialog, preview column, popover, etc.).
 */
export interface ObservationsMapTimeSeriesConfiguratorController {
  openFor: (index: number | null) => void;
}

const ObservationsMapTimeSeriesConfiguratorContext =
  createContext<ObservationsMapTimeSeriesConfiguratorController | null>(null);

export const ObservationsMapTimeSeriesConfiguratorProvider =
  ObservationsMapTimeSeriesConfiguratorContext.Provider;

export function useObservationsMapTimeSeriesConfigurator(): ObservationsMapTimeSeriesConfiguratorController {
  const controller = useContext(ObservationsMapTimeSeriesConfiguratorContext);
  if (!controller) {
    throw new Error(
      "useObservationsMapTimeSeriesConfigurator must be used within its provider",
    );
  }
  return controller;
}
